import { environment } from "src/environments/environment"

export class urls {
    static SERVER_URL = environment.baseUrl
    static API_URL = environment.baseUrl + 'api/'  
    // User
    static SIGNIN_URL = 'auth/signin'
    static FORGOT_URL = 'auth/forgot'
    static PROFILE_URL = 'auth/me'
    static REFRESH_TOKEN = "auth/refresh-tokens"
    static CHANGE_PASSWORD_URL = 'users/password'
    static CHANGE_PROFILE_IMAGE = 'users/picture'
    // Staff
    static STAFF_URL = 'staffs'
    static STAFF_CREATE_URL = 'staffs/create'
    // Driver
    static DRIVERS_URL = 'drivers/companies'
    // static ADD_DRIVER_URL = 'drivers'
    static DRIVER_RESET_PASSWORD_URL = 'drivers/resetpassword'
    // Company
    static GET_COMPANIES = 'companies'
    static DISPATCH_CENTER_HISTOR_URL = 'dispatches/company'
    // Trips
    static ASSIGN_TRIPS = 'trips'
    static SIGNATURE_UPDATE = 'signature'
    static ASSIGN_EVENTS = 'events'
    static ADJUST_TRIPS = 'billings'
    static ADJUST_BILLING_TRIPS = 'fundingsource-billings'
    static RAW_REPORT = 'billings/report'
    static FS_RAW_REPORT = 'fundingsource-billings/report'
    static OPERATION_TRIPS = 'trips/operations'
    static STANDING_ORDER = 'standing-orders'
    static PARSE_TRIPS = 'trips/parse'
    static SINGLE_TRIP = 'assigns/singletrip'
    static ASSIGN_COMPANY = 'trips/status-update'
    static AUTO_DISTRIBUTE = 'auto-distribute'
    // Notification
    static NOTIFICATIONS_URL = 'notifications'
    // Funding Source
    static FUNDING_SOURCE_LIST = 'cooperates'
    static DOCUMENTS = 'documents'
    static MEMBER_UPLOAD = 'members/upload'
    static PARSE_MEMBER='members/parse'
    static SPACETYPES = 'space-types'
    static LEVELOFSERVICE = 'level-of-service'
    static PICKER = '/picker'
    static COMPANIES = 'companies'
    static SIGNUPS = 'signup'
    static CREDENTIAL_COMPANIES = 'credentials-companies'
    static DRIVERS = 'drivers'
    static COMPANY_DRIVERS = 'drivers/company'
    static CREDENTIAL_VEHICLES = 'credentials-vehicles'
    static VEHICLES = 'vehicles'
    static COMPANY_VEHICLES = 'vehicles/company'
    // Fares
    static FARES = 'fares'
    static COMPANY_FARRES = 'fares/company'
    static FUNDING_SOURCE_FARRES = 'fares/fundingsource'
    static FARE_ESTIMATION = 'fare-estimation'
    static THRESHOLD = 'thresholds'
    // users
    static ADD_USERS = 'auth/register'
    static USERS = 'users'
    static ROLES = 'roles'
    static MEMBERS = 'members'
    static MEMBERS_TRIPS = 'members/trips'
    static PERMISSIONS = 'roles/permissions'
    static TYPES = 'roles/types'
    static FORGET_PASSWORD = 'auth/forgot-password'
    static RESET_PASSWORD = 'auth/reset-password'
    static APPOINTMENT_TYPES = 'appointment-types'
    static ADDONS = 'addons'
    static TRIP_ATTACHMENT = 'upload'
    static DASHBOARD = 'dashboard'
    static SERVICE_AREAS = 'service-areas'
    static FUNDING_SOURCES = 'fundingsources'
    static SEARCH_FUNDING_SOURCES = 'fundingsources/search'
    static SEARCH_MEMBERS = 'members/search'
    static STATISTICS = 'trips/kpis'
    static BUSINESS_REPORT = 'trips/report/business'
    static CHANGE_REASON = 'change-reasons'
    static PLACE_TYPES = 'place-types'
    static THRESHOLDS_COMPANY = 'thresholds-dashboard/company'
    static EVENT = 'events'
    static GPS = 'gps'
    static GPS_ONLINE = 'gps/online'
    static DRIVER_ACTIVITY = 'driver-activity'
    static NEARBY_DRIVERS = 'nearby'
    static NEARBY_ONLINE = 'driver-activity/online'
    
    static COMPANY_CONFIGURATION = 'company-configurations'
    static CONFIG_COMPANY_WISE = 'company-configurations/company'
    static GLOBAL_CONFIGURATION = 'configurations'
    static SYNC = 'sync'
    static QUICKBOOK = 'quickbooks'
    static CUSTOMERS = 'customers'
    static INVOICES = 'invoices'
    static SERVICES = 'services'
    static ACCOUNTS  = 'accounts'
    static BILLING_TRIPS_STATUS_UPDATE = 'billings/status-update'
    static UPDATE_PENDING_TRIP_STATUS = 'pending-status-update'
}